import { render, staticRenderFns } from "./migrateInstructor.vue?vue&type=template&id=2a420424&"
import script from "./migrateInstructor.vue?vue&type=script&lang=js&"
export * from "./migrateInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports